import { generateUtilityClasses } from "@mui/material";
const simpleSelectName = "TidalSimpleSelect";
const simpleSelectClasses = generateUtilityClasses(
  simpleSelectName,
  /**
   * This array should include an entry for each ClassKey
   * See the themeable component stories for more info https://preview.tidal.workwave.io/#/?story=components__ThemeableComponents__README
   */
  ["root", "label", "select", "helperText"]
);
export {
  simpleSelectClasses,
  simpleSelectName
};
//# sourceMappingURL=classes.js.map
